<template>
  <section
    class="section"
    :class="getClass">
    <div :class="getContainer">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'BaseSection',

  props: {
    danger: Boolean,
    fluid: Boolean,
    info: Boolean,
    large: Boolean,
    light: Boolean,
    primary: Boolean,
    secondary: Boolean,
    small: Boolean,
    white: Boolean
  },

  computed: {
    getColor () {
      if (this.danger) {
        return 'bg-danger'
      }

      if (this.light) {
        return 'bg-light'
      }

      if (this.primary) {
        return 'bg-primary'
      }

      if (this.secondary) {
        return 'bg-secondary'
      }

      if (this.info) {
        return 'bg-info'
      }

      if (this.white) {
        return 'bg-white'
      }

      return ''
    },

    getContainer () {
      return this.fluid ? 'container-fluid' : 'container'
    },

    getClass () {
      return this.$_.trim(`${this.getSize} ${this.getColor}`)
    },

    getSize () {
      if (this.small) {
        return 'section-small'
      }

      if (this.large) {
        return 'section-large'
      }

      return 'section-normal'
    }
  }
}
</script>
